import { Container, Box, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import person1 from '../assets/image/Image.png';
import person2 from '../assets/image/Image2.png';
import person3 from '../assets/image/Image3.png';
import person4 from '../assets/image/Image4.png';

export const About = () => {

  const navigate = useNavigate();

  return (
    <div className="about-page">
      {/* Page Title */}
      <div className="pointer d-flex" onClick={() => { navigate('/') }}><img width="22" height="22" src="https://img.icons8.com/sf-ultralight-filled/25/00c062/chevron-left.png" alt="chevron-left" />
        <p className="mb-0 ms-1 back">Back to Home</p></div>
      <Box textAlign="center" py={2} className="about-row">
        <Typography variant="h3" component="h1" fontWeight="600" className="text-left ms-1 ab-text">
          About Us
        </Typography>
      </Box>

      <Container disableGutters maxWidth={false} sx={{ mb: 4, mx: 0 }}>
        <div className="border border-[#B7B7B7] p-4">
          {/* Mission */}
          <Box textAlign="left">
            <Typography variant="h4" gutterBottom className="text-left about-head" fontWeight="600">
              Our Mission
            </Typography>
            <Typography variant="body1" className="ab-body">
              Democratize access to product profit margins, CEO–worker pay gaps,
              and corporate tax avoidance, empowering consumers to align spending
              with their values and budgets.
            </Typography>
          </Box>

          <Box my={2} textAlign="left">
            <Typography variant="h4" gutterBottom className="text-left about-head" fontWeight="600">
              Our Name
            </Typography>
            <Typography variant="body1" className="ab-body">
              Aysa is named after our founder’s mother — the first woman in her Sudanese village to attend school. Her courage to choose education over expectation reflects the very heart of what we stand for. <br />
              At Aysa, we believe knowledge is power. Just as she broke barriers through access to learning, we aim to break barriers through access to truth, giving consumers the data they need to make informed, ethical choices. <br />
              Aysa is more than a name. It’s a legacy of empowerment, and the power of choice made visible
            </Typography>
          </Box>

          {/* Our Visiom */}
          <Box my={2} textAlign="left">
            <Typography variant="h4" gutterBottom className="text-left about-head" fontWeight="600">
              Our Vision
            </Typography>
            <Typography variant="body1" className="ab-body">
              A world where every consumer knows exactly what they’re paying
              for—and has the power to choose with clarity, confidence, and
              purpose.
            </Typography>
          </Box>

          {/* Who We Are */}
          <Box my={2} textAlign="left">
            <Typography variant="h4" gutterBottom className="text-left about-head" fontWeight="600">
              Who We Are
            </Typography>
            <Typography variant="body1" className="ab-body">
              Aysa is a transparency platform for shoppers that empowers you to
              see what you’re really paying for—revealing product profit margins,
              CEO–worker pay gaps, and corporate tax avoidance.
            </Typography>
          </Box>

        </div>
        {/* The Team */}

        <div className="border p-4 mt-4">
          <Box mb={0}>
            <Typography variant="h4" gutterBottom className="about-head" fontWeight="600">
              The Team:
            </Typography>

            <Grid item xs={12} mb={2}>

              <div className="about-section ">
                <div>
                  <Typography variant="h6" className="ab-name">Mohy Omer - Founder and CEO</Typography>

                  <Typography variant="body2" className="about-mr ab-body" textAlign={"justify"} marginRight={2} >
                    After nearly a decade working with the U.S. government and
                    international organizations on development and human rights, Mohy
                    saw a powerful truth: political freedom and economic freedom are
                    inseparable. He realized a market can’t be truly free unless
                    consumers are equipped with real knowledge—what it costs to make
                    the products they buy, how much tax corporations avoid each year,
                    and the size of the CEO–frontline worker pay gap.
                  </Typography>
                  {/* <br></br>
                  <Typography variant="body2" textAlign={"justify"} marginRight={2} className="about-hide ab-body">
                    That insight sparked Aysa. Drawing on his research background and
                    technical skills, Mohy spent years building methods to collect,
                    analyze, and present complex data in ways the public can actually
                    use. Once he proved the concept, he invited his then-girlfriend
                    and a close friend to join him in turning Aysa into a reality.
                  </Typography>
                  <br></br> */}
                  {/* <Typography variant="body2" textAlign={"justify"} marginRight={2} className="about-hide ab-body">
                    A former refugee from Sudan, Mohy’s life has been defined by
                    resilience and purpose. He is deeply committed to information
                    freedom and believes everyone has the right to clear, trustworthy
                    data so they can make informed choices—and, ultimately, help shape
                    a fairer economy.
                  </Typography> */}

                </div>
                <img src={person1} className="about-img" />

              </div>

            </Grid>

            <Grid item xs={12} mb={4}>

              <div className="about-section about-reverse">
                <img src={person2} className="about-img" />
                <div>
                  <Typography variant="h6" className="about-mr ab-name" marginLeft={2} >
                    Andreas Decker - Software Engineer
                  </Typography>
                  <Typography variant="body2" className="about-mr ab-body" textAlign={"justify"} marginLeft={2}>
                    Andreas Decker is a seasoned software engineer with more than a
                    decade of experience building resilient back-end systems and
                    mentoring emerging talent. From his university days through
                    industry roles, he’s designed and implemented infrastructure for
                    companies and academic departments alike—tackling complex
                    technical problems with calm rigor and a builder’s curiosity.
                  </Typography>
                  <br></br>
                  <Typography variant="body2" textAlign={"justify"} marginLeft={2} className="about-hide ab-body">
                    A passionate educator, Andreas has taught and supervised students
                    across computer science disciplines, sharing practical lessons in
                    programming, systems architecture, and data management. His
                    classrooms and code reviews alike focus on clarity, craftsmanship,
                    and helping people grow.
                  </Typography>
                  <br></br>
                  <Typography variant="body2" textAlign={"justify"} marginLeft={2} className="about-hide ab-body">
                    Driven by a belief in transparency and consumer empowerment,
                    Andreas is committed to giving people the information they need to
                    make informed choices—especially around product profit margins and
                    how value is shared. Through his engineering work, he builds tools
                    that turn opaque data into accessible insight, advancing more
                    accountable and ethical markets.
                  </Typography>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} mb={4}>
              <div className="about-section ">
                <div>
                  <Typography variant="h6" className="ab-name">QI (Alice) Wang - Data Analyst</Typography>
                  <Typography variant="body2" className="about-mr ab-body" textAlign={"justify"} marginRight={2}>
                    Qi Wang is a highly skilled statistician and data scientist with a
                    Master’s degree in Applied Statistics and a Ph.D. in Statistics.
                    With extensive expertise in statistical modeling, data analysis,
                    and advanced computational methods, she brings a wealth of
                    knowledge to her work.
                  </Typography>
                  <br></br>
                  <Typography variant="body2" textAlign={"justify"} marginRight={2} className="about-hide ab-body">
                    Throughout her career, Qi has specialized in developing and
                    fitting robust statistical models, ensuring data accuracy, and
                    conducting comprehensive analyses to derive meaningful insights.
                    Her meticulous approach and deep understanding of statistical
                    theory and application make her a valuable asset to any project.
                  </Typography>
                  <br></br>
                  <Typography variant="body2" textAlign={"justify"} marginRight={2} className="about-hide ab-body">
                    At Aysa, Qi provides critical statistical support, ensuring the
                    integrity and reliability of the models used to process and
                    present data. She oversees the development of accurate and
                    transparent data analyses, ensuring they align with Aysa's mission
                    of empowering consumers with accessible and trustworthy
                    information. Qi’s expertise not only strengthens the technical
                    foundation of Aysa’s platform but also underscores the company’s
                    commitment to precision and credibility.
                  </Typography>
                </div>
                <img src={person3} className="about-img" />
              </div>
            </Grid>

            <Grid item xs={12} mb={4}>

              <div className="about-section about-reverse">
                <img src={person4} className="about-img" />
                <div>
                  <Typography variant="h6" className="about-mr ab-name" marginLeft={2} >
                    Rob Jones
                  </Typography>
                  <Typography variant="body2" className="about-mr ab-body" textAlign={"justify"} marginLeft={2}>
                    Rob is a UX designer and product strategist focused on turning complexity into clarity.
                     With a background in industrial and enterprise design systems, he brings the precision of data visualization and the empathy of storytelling to Aysa’s interface.

                    
                  </Typography>
                  <br></br>
                  <Typography variant="body2" textAlign={"justify"} marginLeft={2} className="about-hide ab-body">
                    Rob believes transparency should feel effortless, that ethical design can inspire ethical decisions. His work ensures Aysa isn’t just powerful, but intuitive, human, and beautiful to use.
                  </Typography>
                  <br></br>
                  {/* <Typography variant="body2" textAlign={"justify"} marginLeft={2} className="about-hide">
                    Driven by a belief in transparency and consumer empowerment,
                    Andreas is committed to giving people the information they need to
                    make informed choices—especially around product profit margins and
                    how value is shared. Through his engineering work, he builds tools
                    that turn opaque data into accessible insight, advancing more
                    accountable and ethical markets.
                  </Typography> */}
                </div>
              </div>
            </Grid>


          </Box>
        </div>

        <Box>
          <div className="border p-4 mt-4">
            <Grid item xs={12}>
              <Typography variant="h4" className="about-head " gutterBottom >
                Aysa Legal Disclaimer
              </Typography>
              <Typography variant="body2" className="ab-body">
                Aysa provides informational content for education and research.
                Some figures are estimates based on public sources that are
                mathematically and statistically modeled. Nothing here is
                investment, tax, or legal advice. Company names and trademarks are
                used for identification only; no affiliation or endorsement is
                implied.
              </Typography>
              <br></br>
              <Typography variant="body2" className="ab-body">
                Aysa is a data-driven platform that aggregates and analyzes
                publicly available information about companies and products.
                Unless expressly labeled “reported,” figures are modeled and
                derived from disclosed facts and stated assumptions. We regularly
                update our models to capture the latest reported data. Our
                platform precisely highlights the following:
              </Typography>
              <ul className="aboutlgealList" className="ab-body">
                <li>
                  <b>No Professional Advice.</b> Aysa’s content is for{" "}
                  <b>informational and educational</b> purposes only and does not
                  constitute investment, tax, accounting, or legal advice.
                </li>
                <li>
                  <b>Estimation.</b> Where values are modeled, we disclose
                  assumptions and may show ranges. Different reasonable
                  assumptions may yield different results.
                </li>
                <li>
                  <b>No Allegations of Illegality.</b> References to “tax
                  avoidance” mean <b>lawful</b> reduction of tax liability using
                  deductions, deferrals, credits, and jurisdictional rules. We do
                  <b>not </b> allege “tax evasion” or unlawful conduct.
                </li>
                <li>
                  <b>Trademarks & Copyright.</b> Company names and logos may
                  appear under<b>nominative fair use</b> to identify brands;
                  appearance does not imply sponsorship or endorsement. All other
                  materials remain the property of their respective owners.
                </li>
                <li>
                  <b>Errors & Corrections.</b> If you believe any content is
                  inaccurate, please use the “Report an issue” link. We will
                  review submissions and, where warranted, correct or clarify
                  content and note changes in our <b>Corrections Log.</b>
                </li>
                <li>
                  <b>Jurisdiction.</b> Content is published by Aysa for a global
                  audience. Laws differ by jurisdiction; users are responsible for
                  how they use our content.
                </li>
              </ul>
              <Typography variant="body2" className="ab-body">
                By using Aysa, you agree to our <b>Terms of Use</b> and{" "}
                <b>Privacy Policy.</b>
              </Typography>
            </Grid>
          </div>
        </Box>




      </Container>
    </div >
  );
};
